import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import * as actionTypes from '../../store/actions/actionTypes';
import BoxiMapTemp from "../../components/page/map/BoxiMap/BoxiMapTemp";
import KeyListTemp from "../../components/page/map/KeyList/KeyListTemp";
import ImageComponent from './ImageComponent';
import IconButtonComponent from './IconButtonComponent';
import SelectionListVehicles from './SelectionListVehicles';
import SelectionListDuration from './SelectionListDuration.js';
import classes from './ClientMapTheme.module.scss';
class MapPageTemp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showListTimePeriod: false,
      showTrucksList: false,
      totalSelectedTrucks: 0,
      durationIndex: -1,
      selectedTrucksNames: [], 
      initialClick: true,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selected !== this.props.selected || this.props.index !== prevProps.index) {
      this.setState({
        showListTimePeriod: false,
        showTrucksList: false,
        totalSelectedTrucks: 0,
        durationIndex: this.props.index,
        selectedTrucksNames: [],
        initialClick: true
      })
    }
  }

  updateSelectedTrucksNames = (value) => {
    this.setState({
      selectedTrucksNames: [...value],
      initialClick: false
    })
  }
 // 

  handleTimePeriodClick = (value) => {
    if(Number(value) === 0 || Number(value) > 0){
      this.setState((prevState) => ({
        showListTimePeriod: !prevState.showListTimePeriod,
        durationIndex: Number(value),
      }));
      this.props.updateInitialClick(false)
    } else {
      this.setState((prevState) => ({
        showListTimePeriod: !prevState.showListTimePeriod,
      }));
      this.props.updateInitialClick(false)

    }
  };

  handleTruckClick = () => {
    this.setState((prevState) => ({
      showTrucksList: !prevState.showTrucksList,
    }));
  };

  updateSelectedTrucks = (value) => {
      this.setState({
        totalSelectedTrucks: Number(value)
      })
  }

  
  render() {
    const { showListTimePeriod, showTrucksList } = this.state;
    const { index, loading } = this.props;
    const duration = ['1 Day', '1 Week', '1 Month']
    return (
      <Fragment>
        <Helmet>
          <title>Boxi | Map</title>
        </Helmet>
        <BoxiMapTemp loading={loading}/>
        <div
          className={classes.map_fields_container}
        >
          {this.props.userProfileUrl ? 
          (<ImageComponent src={this.props.userProfileUrl} alt="Empty Chat" classes={classes} />)
           : 
           (<></>)}

            <IconButtonComponent
              label={!this.props.initialClick ? duration[index] :`Select Time Frame`}
              classes={classes}
              onClick={this.handleTimePeriodClick}
              arrow={showListTimePeriod}
            />
            {showListTimePeriod &&
             
                <SelectionListDuration items={duration} classes={classes} handleTimePeriodClick={this.handleTimePeriodClick} />
            }

            <IconButtonComponent
              label={this.state.selectedTrucksNames.length > 1 ? `${this.state.selectedTrucksNames.length} Trucks` : this.state.selectedTrucksNames.length === 1 ? `${this.state.selectedTrucksNames.length} Truck` : "Select Trucks"}
              classes={classes}
              onClick={this.handleTruckClick}
              arrow={showTrucksList} />
            {showTrucksList &&
                <SelectionListVehicles initialClick={this.state.initialClick} selectedTrucksNames={this.state.selectedTrucksNames} updateSelectedTrucksNames={this.updateSelectedTrucksNames} classes={classes} updateSelectedTrucks={this.updateSelectedTrucks}/>
            }

          {/* <KeyListTemp /> */}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    index: state.clientDashboard.timePeriod,
    selected: state.clientDashboardTemp.selected,
    userProfileUrl: state.clientDashboardTemp.userProfileUrl,
    initialClick: state.clientDashboardTemp.initialClick
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateInitialClick: (value) => {
      dispatch({
        type: actionTypes.UPDATE_INITIAL_CLICK,
        value: value
      });
    },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(MapPageTemp);
